import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { generateFollowupEmail } from '../../lib/openai';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMail, FiLoader, FiCopy, FiCheck } = FiIcons;

function EmailGenerator({ customer }) {
  const [emailContent, setEmailContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [interaction, setInteraction] = useState('');
  const [copied, setCopied] = useState(false);

  const generateEmail = async () => {
    setIsLoading(true);
    try {
      const email = await generateFollowupEmail(
        `${customer.firstName} ${customer.lastName}`,
        customer.interestedVehicle || 'our vehicles',
        interaction || 'an initial inquiry about vehicles'
      );
      setEmailContent(email);
    } catch (error) {
      console.error('Error generating email:', error);
      setEmailContent('Failed to generate email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(emailContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiMail} className="w-5 h-5 mr-2 text-primary-500" />
        AI Email Generator
      </h3>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Previous Interaction or Context
          </label>
          <textarea
            value={interaction}
            onChange={(e) => setInteraction(e.target.value)}
            placeholder="E.g., Customer visited the showroom last week and test drove a Honda CR-V"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            rows={3}
          />
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={generateEmail}
          disabled={isLoading}
          className="w-full bg-primary-600 text-white py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 disabled:opacity-50"
        >
          {isLoading ? (
            <>
              <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin" />
              <span>Generating...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiMail} className="w-4 h-4" />
              <span>Generate Follow-up Email</span>
            </>
          )}
        </motion.button>

        {emailContent && (
          <div className="mt-4 border border-gray-200 rounded-lg p-4 bg-gray-50 relative">
            <pre className="whitespace-pre-wrap text-sm font-sans">{emailContent}</pre>
            <button
              onClick={copyToClipboard}
              className="absolute top-2 right-2 p-2 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-full transition-colors"
              title="Copy to clipboard"
            >
              <SafeIcon icon={copied ? FiCheck : FiCopy} className={`w-4 h-4 ${copied ? 'text-green-500' : ''}`} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailGenerator;